import { STEP_LIBRARY } from '@/lib/dd-queue/data/steps'

export interface HistoryColumnDef {
  id: string
  label: string
  defaultWidth: number
  minWidth: number
  sortType: 'text' | 'number' | 'date'
  defaultHidden: boolean
  step?: string
}

const CORE: HistoryColumnDef[] = [
  { id: 'id', label: 'ID', defaultWidth: 150, minWidth: 100, sortType: 'text', defaultHidden: false },
  { id: 'product', label: 'Product / Line', defaultWidth: 240, minWidth: 140, sortType: 'text', defaultHidden: false },
  // F-106 — the assigned SKU / UIN of a completed line, searchable and sortable.
  { id: 'sku', label: 'SKU', defaultWidth: 120, minWidth: 80, sortType: 'text', defaultHidden: false },
  { id: 'uin', label: 'UIN', defaultWidth: 120, minWidth: 80, sortType: 'text', defaultHidden: true },
  { id: 'customer', label: 'Customer', defaultWidth: 130, minWidth: 90, sortType: 'text', defaultHidden: false },
  { id: 'submitted', label: 'Submitted', defaultWidth: 100, minWidth: 80, sortType: 'date', defaultHidden: false },
  { id: 'completed', label: 'Completed', defaultWidth: 100, minWidth: 80, sortType: 'date', defaultHidden: false },
  { id: 'turnaround', label: 'Turnaround', defaultWidth: 110, minWidth: 80, sortType: 'number', defaultHidden: false },
]

const STEP_COLS: HistoryColumnDef[] = STEP_LIBRARY.map((s) => ({
  id: `step:${s.key}`,
  label: s.name,
  defaultWidth: 140,
  minWidth: 90,
  sortType: 'text' as const,
  defaultHidden: true,
  step: s.key,
}))

export const HISTORY_COLUMN_DEFS: HistoryColumnDef[] = [...CORE, ...STEP_COLS]
export const HISTORY_COLUMN_BY_ID = Object.fromEntries(HISTORY_COLUMN_DEFS.map((c) => [c.id, c]))
